import React from 'react';
import ActivateAccount from '@/pages/ActivateAccount';

const ActivateAccountLayout: React.FunctionComponent<React.PropsWithChildren> = () => <ActivateAccount />;

export default ActivateAccountLayout;
